import * as z from "zod";

const deletionMetadataSchema = z.object({
  created_timestamp_secs: z.number().int().nonnegative(),
  deletion_type: z.enum(["self", "admin", "migration"]),
});

// Lives at _deleted_users/{uid}, outside the recursively deleted user tree.
// Reports must only count completed records as deletions.
export const firestoreDocDeletedUserSchema = z.discriminatedUnion("status", [
  deletionMetadataSchema.extend({
    status: z.literal("pending"),
    deleted_timestamp_secs: z.null(),
  }),
  deletionMetadataSchema.extend({
    status: z.literal("completed"),
    deleted_timestamp_secs: z.number().int().nonnegative(),
  }),
]);

export type BreadDeletedUser = z.infer<typeof firestoreDocDeletedUserSchema>;
export type BreadUserDeletionType = BreadDeletedUser["deletion_type"];
